module.exports = __webpack_public_path__ + "static/media/industrial-workers.894760a0.webm";